import { useEffect } from 'react'

// Show error in toast (must be before any early returns)
export function useErrorToastEffect(
  error: string | null
) {
  useEffect(() => {
    if (error) {
      // Import showError dynamically to avoid circular dependencies
      import('../../../lib/toast').then(({ showError }) => {
        showError(error)
      })
    }
  }, [error])
}
